import styled from "styled-components";
import { Colors } from "~/config/Colors";

const CustomSelect = styled.select`
  font-size: 0.8rem;
  line-height: 1;
  height: 2.5rem;
  //box-shadow: 0px 0px 10px rgb(0 0 0 / 5%);
  border: 0;
  // border: 0.1em solid ${Colors.Color1};
  border-radius: 0.5rem;
  width: fit-content;
  max-width: 100%;
  padding: 0em 0.5rem;

  ${({notForm}) => {
    if (notForm == true) {
      return `
        background-color: ${Colors.Color22};
        color: ${Colors.Color7} !important;
      `;
    } else {
      return `
        background-color: ${Colors.Color23};
        color: ${Colors.Color7} !important;
      `;
    }
  }}

  option {
    background-color: ${Colors.Color21};
    color: ${Colors.Color7} !important;
  }

  option:disabled {
    background-color: ${Colors.Color12};
    color: ${Colors.Color7} !important;
  }

  :disabled {
    background-color: ${Colors.Color12};
    border: 0.1rem solid ${Colors.Color12};
    opacity: 1;
  }

  :focus,
  :hover {
    // border: 0.1rem solid ${Colors.Color4};
  }
`;

export default CustomSelect;
